import React, { Component } from 'react';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import API from '../../services/API';
import Table from './components/Table';
import {Alert, Button, Col, Row} from "react-bootstrap";
import FieldGroup from "../../components/FieldGroup";
import { handleFieldChange } from "../../Utils";

class PeerClickOfferDomain extends Component {
    constructor() {
        super();

        this.state = {
            isLoading: false,
            offerId: '',
            oldDomain: '',
            newDomain: '',
            message: '',
            messageStyle: ''
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFieldChange = handleFieldChange.bind(this);
        this.setMessage = this.setMessage.bind(this);
    }

    handleSubmit(e) {
        e.preventDefault();

        this.setState({ isLoading: true });

        let { offerId, oldDomain, newDomain } = this.state;

        if(!offerId) offerId = '';
        else offerId = offerId.split(',').map(id => parseInt(id));

        API.PeerClickOffer.updateDomain(oldDomain, offerId, newDomain)
            .then((res) => {
                if(res.success) {
                    this.setMessage('Success!', 'success');
                }
                else {
                    this.setMessage('Something got wrong!', 'danger');
                }
            })
            .catch(() => {
                this.setMessage('Something got wrong!', 'danger');
            });
    }

    setMessage(message, messageStyle) {
        this.setState({ isLoading: false, message, messageStyle });
    }

    getTable() {
        const { report } = this.state;

        if(!report.length) return <p>No data</p>;

        return <Table report={report}/>
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="PeerClick Domain Update"/>

                <form onSubmit={this.handleSubmit}>
                    <Row>
                        <Col lg={4}>
                            <FieldGroup
                                name="offerId"
                                label="Offer ID:"
                                onChange={this.handleFieldChange}
                                value={this.state.offerId}
                            />
                        </Col>
                        <Col lg={4}>
                            <FieldGroup
                                name="oldDomain"
                                label="Old domain:"
                                onChange={this.handleFieldChange}
                                value={this.state.oldDomain}
                            />
                        </Col>
                        <Col lg={4}>
                            <FieldGroup
                                name="newDomain"
                                label="New domain:"
                                onChange={this.handleFieldChange}
                                value={this.state.newDomain}
                            />
                        </Col>
                    </Row>

                    {
                        this.state.message ?
                            <Alert bsStyle={this.state.messageStyle}>{this.state.message}</Alert> :
                            null
                    }

                    <Button type="submit" bsStyle="success" className="m-b-15" >Update</Button>
                </form>
            </Container>
        );
    }
}

export default PeerClickOfferDomain;


// WEBPACK FOOTER //
// ./src/scenes/PeerClickOfferDomain/index.js